export function getInitials(name: string): string {
  return name
    .split(' ')
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

// "michael.allen@…" reads as MA; a bare local part gives one letter.
export function getEmailInitials(email: string): string {
  const local = email.split('@')[0] ?? '';
  return local
    .split(/[._+-]+/)
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}
